export const CURRENT_USER_ID = 'me';
